/**
 * @generated by @puffin-tooling/esm-build — DO NOT EDIT BY HAND.
 *
 * Source of truth: this package's CJS entry (`lib/index.js`).
 * Regenerate with `pnpm esm:build`; CI fails if this file is stale
 * (see the esmBuildFreshness cross-app contract).
 *
 * This RE-EXPORTS the CJS surface rather than duplicating it. Hand-editing
 * it reintroduces PLN-CALENDAR-RULE-001 D4: two copies of one module,
 * drifting silently.
 */

import cjs from '../index.js';

export default cjs;

export const {
  ACCOUNT_ACTIVATION_SYSTEM_ACTOR,
  ACCOUNT_ACTIVATION_SYSTEM_ACTOR_VALUES,
  ACCOUNT_AUTHENTICATION_RESET_REFUSAL,
  ACCOUNT_AUTHENTICATION_RESET_REFUSAL_VALUES,
  ACCOUNT_DEACTIVATION_REFUSAL,
  ACCOUNT_DEACTIVATION_REFUSAL_VALUES,
  ACCOUNT_DEACTIVATION_SYSTEM_ACTOR,
  ACCOUNT_DEACTIVATION_SYSTEM_ACTOR_VALUES,
  ACCOUNT_PASSWORD_RESET_REFUSAL,
  ACCOUNT_PASSWORD_RESET_REFUSAL_VALUES,
  ACCOUNT_REACTIVATION_REFUSAL,
  ACCOUNT_REACTIVATION_REFUSAL_VALUES,
  ACCOUNT_STATUS,
  ACCOUNT_STATUS_BADGE_TONES,
  ACCOUNT_STATUS_LABELS,
  ACCOUNT_STATUS_VALUES,
  ACCOUNT_UNDO_OUTCOME,
  ACCOUNT_UNDO_OUTCOME_VALUES,
  ACTIVE_EMPLOYEE_SCHEDULE_STATUSES,
  ANOMALY_TYPE,
  ANOMALY_TYPE_VALUES,
  ATTAINMENT_STATUS,
  ATTAINMENT_STATUS_VALUES,
  AUTOPAY_AUTHORIZATION_STATUS,
  AUTOPAY_AUTHORIZATION_STATUS_BADGE_TONES,
  AUTOPAY_AUTHORIZATION_STATUS_TRANSITIONS,
  AUTOPAY_AUTHORIZATION_STATUS_VALUES,
  AVAILABILITY_TYPE,
  AVAILABILITY_TYPE_VALUES,
  BADGE_TONE,
  BADGE_TONE_VALUES,
  BILLING_ATTENTION_SUBSCRIPTION_STATUSES,
  CALENDAR_SYNC_REVOKE_REFUSAL,
  CALENDAR_SYNC_REVOKE_REFUSAL_VALUES,
  CARRIER_SCAN_STATUS,
  CARRIER_SCAN_STATUS_VALUES,
  CLOSED_DAY_KIND,
  CLOSED_DAY_KIND_VALUES,
  CUSTOMER_STATUS,
  CUSTOMER_STATUS_ASSIGNABLE_VALUES,
  CUSTOMER_STATUS_VALUES,
  DAILY_GOALS_FALLBACK_REASON,
  DAILY_GOALS_FALLBACK_REASON_VALUES,
  DAY_PLAN_STATUS,
  DAY_PLAN_STATUS_VALUES,
  DAY_PORTION,
  DAY_PORTION_FRACTION,
  DAY_PORTION_VALUES,
  DEFAULT_ACCOUNT_STATUS,
  DEFAULT_DAY_PORTION,
  DEFAULT_EMPLOYMENT_STATUS,
  DEFAULT_EMPLOYMENT_TYPE,
  DEFAULT_TTS_PROVIDER,
  DOW_WEIGHT_BASIS,
  DOW_WEIGHT_BASIS_VALUES,
  EMPLOYEE_SCHEDULE_STATUS,
  EMPLOYEE_SCHEDULE_STATUS_VALUES,
  EMPLOYMENT_STATUS,
  EMPLOYMENT_STATUS_BADGE_TONES,
  EMPLOYMENT_STATUS_LABELS,
  EMPLOYMENT_STATUS_VALUES,
  EMPLOYMENT_TYPE,
  EMPLOYMENT_TYPE_VALUES,
  EXCLUDED_DAY_SOURCE,
  EXCLUDED_DAY_SOURCE_VALUES,
  FORECAST_ACCURACY_SALES_BASIS,
  FORECAST_ACCURACY_SALES_BASIS_VALUES,
  FORECAST_SCORING_EXCLUSIONS,
  FORECAST_SCORING_EXCLUSIONS_VALUES,
  HISTORICAL_BASIS,
  HISTORICAL_BASIS_VALUES,
  HISTORY_EXCLUSION_COUNTED_SOURCES,
  HISTORY_EXCLUSION_SOURCE,
  HISTORY_EXCLUSION_SOURCE_PRECEDENCE,
  HISTORY_EXCLUSION_USER_SOURCES,
  HOURLY_WEIGHTS_UNIT,
  INVENTORY_MOVEMENT_TYPES,
  INVITATION_STATUS,
  INVITATION_STATUS_VALUES,
  LEAVE_BLACKOUT_ENFORCEMENTS,
  LEAVE_POLICY_STATUS,
  LEAVE_POLICY_STATUS_VALUES,
  LEAVE_WARNING_CODES,
  LIVE_TENANT_STATUSES,
  LIVE_TTS_PROVIDERS,
  MAILBOX_AGREEMENT_COPY_CHANNEL,
  MAILBOX_AGREEMENT_COPY_CHANNEL_VALUES,
  MAILBOX_AGREEMENT_LANGUAGE,
  MAILBOX_AGREEMENT_LANGUAGE_VALUES,
  MAILBOX_AGREEMENT_SIGNATURE_METHOD,
  MAILBOX_AGREEMENT_SIGNATURE_METHOD_VALUES,
  MAILBOX_AGREEMENT_STATUS,
  MAILBOX_AGREEMENT_STATUS_BADGE_TONES,
  MAILBOX_AGREEMENT_STATUS_TRANSITIONS,
  MAILBOX_AGREEMENT_STATUS_VALUES,
  MAILBOX_AGREEMENT_TEMPLATE_SOURCE,
  MAILBOX_AGREEMENT_TEMPLATE_SOURCE_VALUES,
  MAILBOX_HELD_STATUSES,
  MAILBOX_HOLDER_PLAN_TIER,
  MAILBOX_HOLDER_PLAN_TIER_VALUES,
  MAILBOX_HOLDER_SUBSCRIPTION_STATUS,
  MAILBOX_HOLDER_SUBSCRIPTION_STATUS_VALUES,
  MAILBOX_RENTAL_END_REASON,
  MAILBOX_RENTAL_END_REASON_VALUES,
  MAILBOX_RENTAL_STATUS,
  MAILBOX_RENTAL_STATUS_BADGE_TONES,
  MAILBOX_RENTAL_STATUS_TRANSITIONS,
  MAILBOX_RENTAL_STATUS_VALUES,
  MAILBOX_RENT_PAYMENT_SETTLING_STATUSES,
  MAILBOX_RENT_PAYMENT_STATUS,
  MAILBOX_RENT_PAYMENT_STATUS_BADGE_TONES,
  MAILBOX_RENT_PAYMENT_STATUS_TRANSITIONS,
  MAILBOX_RENT_PAYMENT_STATUS_VALUES,
  MAILBOX_STATUS,
  MAILBOX_STATUS_BADGE_TONES,
  MAILBOX_STATUS_TRANSITIONS,
  MAILBOX_STATUS_VALUES,
  MAILBOX_TYPE,
  MAILBOX_TYPE_VALUES,
  MAIL_ITEM_STATUS,
  MAIL_ITEM_STATUS_BADGE_TONES,
  MAIL_ITEM_STATUS_TRANSITIONS,
  MAIL_ITEM_STATUS_VALUES,
  MAIL_ITEM_TYPE,
  MAIL_ITEM_TYPE_VALUES,
  MONTHLY_ACTUAL_NOTE,
  MONTHLY_ACTUAL_NOTE_VALUES,
  MONTHLY_SET_SOURCE,
  MONTHLY_SET_SOURCE_VALUES,
  OFFLINE_PUNCH_REPORT_KIND,
  OFFLINE_PUNCH_REPORT_KIND_VALUES,
  OFFLINE_PUNCH_REPORT_STATUS,
  OFFLINE_PUNCH_REPORT_STATUS_VALUES,
  OPERATION_RUN_ACTIVE_STATUSES,
  OPERATION_RUN_STATUS,
  OPERATION_RUN_STATUS_BADGE_TONES,
  OPERATION_RUN_STATUS_TRANSITIONS,
  OPERATION_RUN_STATUS_VALUES,
  ORDER_AWAITING_PAYMENT_STATUSES,
  ORDER_CANCELLABLE_STATUSES,
  ORDER_CARRIER_FULFILLMENT_STATUSES,
  ORDER_FINAL_STATUSES,
  ORDER_FULFILLMENT_STATUS,
  ORDER_FULFILLMENT_STATUS_BADGE_TONES,
  ORDER_FULFILLMENT_STATUS_VALUES,
  ORDER_GOODS_LEFT_FULFILLMENT_STATUSES,
  ORDER_LINE_TYPE,
  ORDER_LINE_TYPE_VALUES,
  ORDER_OPEN_STATUSES,
  ORDER_PAYMENT_CLASS,
  ORDER_PAYMENT_FULLY_SETTLED_STATUSES,
  ORDER_PAYMENT_STATUS,
  ORDER_PAYMENT_STATUS_BADGE_TONES,
  ORDER_PAYMENT_STATUS_CLASSES,
  ORDER_PAYMENT_STATUS_VALUES,
  ORDER_PICKUP_FULFILLMENT,
  ORDER_PICKUP_READY_FROM_FULFILLMENT_STATUSES,
  ORDER_REFUND_PAYMENT_STATUSES,
  ORDER_SOURCE,
  ORDER_SOURCE_VALUES,
  ORDER_STATUS,
  ORDER_STATUS_BADGE_TONES,
  ORDER_STATUS_TRANSITIONS,
  ORDER_STATUS_VALUES,
  ORDER_UNCANCELLABLE_FULFILLMENT_STATUSES,
  ORDER_UNSTARTED_FULFILLMENT_STATUS,
  OUTSTANDING_INVITATION_STATUSES,
  PARTNER_STATUS,
  PARTNER_STATUS_VALUES,
  PAYROLL_FUNDING_NOT_CHECKED_REASON,
  PAYROLL_FUNDING_NOT_CHECKED_REASON_VALUES,
  PAYROLL_FUNDING_STATUS,
  PAYROLL_FUNDING_STATUS_BADGE_TONES,
  PAYROLL_FUNDING_STATUS_VALUES,
  PAYROLL_ONBOARDING_STATUS,
  PAYROLL_ONBOARDING_STATUS_BADGE_TONES,
  PAYROLL_ONBOARDING_STATUS_FRESH_FOR_MS,
  PAYROLL_ONBOARDING_STATUS_VALUES,
  PAYROLL_RUN_CANCELLABLE_TYPES,
  PAYROLL_RUN_REVIEW_ACKNOWLEDGEABLE_STATUSES,
  PAYROLL_RUN_SKIPPABLE_STATUSES,
  PAYROLL_RUN_STATUS,
  PAYROLL_RUN_STATUS_TRANSITIONS,
  PAYROLL_RUN_STATUS_VALUES,
  PAYROLL_RUN_TYPE,
  PAYROLL_RUN_TYPE_VALUES,
  PAYROLL_RUN_WITHHOLDING_SWITCHABLE_STATUSES,
  PAY_SCHEDULE_STATUS,
  PAY_SCHEDULE_STATUS_VALUES,
  PAY_TYPE,
  PAY_TYPE_VALUES,
  PERFORMANCE_LABOR_REASON,
  PERFORMANCE_LABOR_REASON_VALUES,
  PERSISTED_TRANSACTION_STATUSES,
  PLANNING_GRAIN,
  PLANNING_GRAIN_VALUES,
  PLATFORM_OWNER_RESTORE_REFUSAL,
  PLATFORM_OWNER_RESTORE_REFUSAL_VALUES,
  PRINT_JOB_STATUS,
  PRINT_JOB_STATUS_BADGE_TONES,
  PRINT_JOB_STATUS_TRANSITIONS,
  PRINT_JOB_STATUS_VALUES,
  PRINT_QUEUE_JOB_ACTIVE_STATUSES,
  PRINT_QUEUE_JOB_STATUS,
  PRINT_QUEUE_JOB_STATUS_BADGE_TONES,
  PRINT_QUEUE_JOB_STATUS_TRANSITIONS,
  PRINT_QUEUE_JOB_STATUS_VALUES,
  PUNCH_CLOSURE_SOURCE,
  PUNCH_CLOSURE_SOURCE_VALUES,
  PURCHASE_ORDER_SOURCES,
  REGISTER_PAYMENT_STATUS,
  REGISTER_PAYMENT_STATUSES,
  RENTAL_BILLING_PERIOD,
  RENTAL_BILLING_PERIOD_VALUES,
  RENTAL_OWNED_EDGES,
  RENTAL_TERM_MONTHS,
  RESTORABLE_OWNER_ACCOUNT_STATUSES,
  ROLE_CHANGE_REFUSAL,
  ROLE_CHANGE_REFUSAL_VALUES,
  ROLLUP_LY_REASON,
  ROLLUP_LY_REASON_VALUES,
  SALES_BASIS_FALLBACK_REASON,
  SALES_BASIS_FALLBACK_REASON_VALUES,
  SALES_BASIS_GRAIN,
  SALES_BASIS_GRAIN_VALUES,
  SALES_BASIS_SOURCE,
  SALES_BASIS_SOURCE_VALUES,
  SCHEDULABLE_PREDICATE,
  SCHEDULE_ABSENCE_REASON,
  SCHEDULE_ABSENCE_REASON_VALUES,
  SCHEDULE_BLOCKER,
  SCHEDULE_BLOCKER_LABELS,
  SELF_REPORTED_ABSENCE_REASONS,
  SHIPMENT_STATUS,
  SHIPMENT_STATUS_ASSIGNABLE_VALUES,
  SHIPMENT_STATUS_BADGE_TONES,
  SHIPMENT_STATUS_OF_CARRIER_SCAN,
  SHIPMENT_STATUS_TRANSITIONS,
  SHIPMENT_STATUS_VALUES,
  SUBSCRIPTION_BILLING_MODE,
  SUBSCRIPTION_BILLING_MODE_VALUES,
  SUBSCRIPTION_STATUS,
  SUBSCRIPTION_STATUS_BADGE_TONES,
  SUBSCRIPTION_STATUS_VALUES,
  TENANT_STATUS,
  TENANT_STATUS_BADGE_TONES,
  TENANT_STATUS_VALUES,
  TERMINAL_ATTENTION_STATUSES,
  TERMINAL_IN_SERVICE_STATUSES,
  TERMINAL_RETIRED_STATUSES,
  TERMINAL_SEAT_HOLDING_STATUSES,
  TERMINAL_STATUS,
  TERMINAL_STATUS_BADGE_TONES,
  TERMINAL_STATUS_TRANSITIONS,
  TERMINAL_STATUS_VALUES,
  TERMINATION_REASON,
  TERMINATION_REASON_VALUES,
  TIME_OFF_REQUEST_STATUS,
  TIME_OFF_REQUEST_STATUS_VALUES,
  TIME_OFF_WITHDRAWAL_STATUS,
  TIME_OFF_WITHDRAWAL_STATUS_VALUES,
  TRANSACTION_REFERENCE_TYPE,
  TRANSACTION_STATUS,
  TRANSACTION_TYPE,
  TRIAL_PERIOD_DAYS,
  TTS_PROVIDER,
  TTS_PROVIDER_VALUES,
  UNACCEPTED_ACCOUNT_STATUSES,
  UNDISCOUNTED_ORDER_LINE_TYPES,
  VOICE_CLONING_PROVIDER,
  VOID_TRANSACTION_STATUS,
  autopayAuthorizationStatusTargets,
  buildEmploymentStatusOptions,
  buildStatusOptions,
  classifyBlackoutOverlap,
  clockMinutes,
  dayPortionCoversWholeDay,
  dayPortionRequiresWindow,
  dayPortionsOverlap,
  deriveAccessState,
  deriveScheduleReadiness,
  isBadgeTone,
  isCustomerSignInAllowed,
  isMailboxHeld,
  isOnRoster,
  isOnboardingCompleted,
  isOperationRunActive,
  isOrderPaymentFullySettled,
  isPortionComplete,
  isPrintQueueJobActive,
  isRentalOwnedEdge,
  isSchedulable,
  isUserHistoryExclusion,
  isWindowInOrder,
  judgeBlackoutOverlap,
  mailItemStatusTargets,
  mailboxAgreementStatusTargets,
  mailboxRentPaymentStatusTargets,
  mailboxStatusTargets,
  operationRunStatusTargets,
  orderPaymentStatusClass,
  orderStatusTargets,
  portionPayload,
  printJobStatusTargets,
  printQueueJobStatusTargets,
  resolveBadgeTone,
  shipmentStatusOfCarrierScan,
  shipmentStatusTargets,
  terminalStatusTargets,
} = cjs;
